<div
  class="co-summary"
  [ngClass]="{
    'co-summary--skl': environment === 'skl',
    'co-summary--content': isConfirmation
  }"
>
  <h3>
    Bestellübersicht
    <small>{{ lotteryNumber }}. {{ lottery.category }}</small>
    <small>Laufzeit: {{ lotteryStartDate }} - {{ lotteryEndDate }}</small>
  </h3>
  <a
    href=""
    [routerLink]="showCartPage ? '/cart' : '/landing'"
    class="co-summary__change"
    [fragment]="showCartPage ? '' : 'lp-form-heading-count'"
    >Ändern</a
  >
  <div class="co-summary__products" *ngFor="let product of products">
    <div class="co-summary__products__item columns small-4">
      {{ product.amount }}x
    </div>
    <div class="co-summary__products__item columns small-4">
      {{ getProductName(product.name) }}
    </div>
    <div class="co-summary__products__item columns small-4 text-right">
      {{
        product.amount * product.price | currency : 'EUR' : 'symbol' : '1.2-2'
      }}
    </div>
  </div>
  <hr />
  <div class="co-summary__products">
    <div class="co-summary__products__item columns small-6">
      Servicepauschale* inkl. gesetzl. MwSt.
    </div>
    <div class="co-summary__products__item columns small-6 text-right">
      {{ serviceFee | currency : 'EUR' : 'symbol' : '1.2-2' }}
    </div>
  </div>
  <div class="co-summary__products" *ngIf="couponCode">
    <div class="co-summary__products__item columns small-6">
      Gutschein ({{ couponCode }})<sup *ngIf="environment === 'skl'">4</sup
      ><sup *ngIf="environment === 'nkl'">5</sup>
    </div>
    <div class="co-summary__products__item columns small-6 text-right">
      -{{ discount | currency : 'EUR' : 'symbol' : '1.2-2' }}
    </div>
  </div>
  <hr class="thick" />
  <div class="co-summary__products" *ngIf="!couponCode">
    <div class="co-summary__products__item columns small-6">
      <strong>Gesamtsumme pro Monat / Klasse:</strong>
    </div>
    <div class="co-summary__products__item columns small-6 text-right">
      <strong>{{ totalPrice | currency : 'EUR' : 'symbol' : '1.2-2' }}</strong>
    </div>
  </div>
  <div class="co-summary__products" *ngIf="couponCode">
    <div class="co-summary__products__item columns small-6">
      <strong>Gesamtsumme im 1. Monat / Klasse:</strong>
    </div>
    <div class="co-summary__products__item columns small-6 text-right">
      <strong>{{ totalPrice | currency : 'EUR' : 'symbol' : '1.2-2' }}</strong>
    </div>
  </div>
  <div class="co-summary__products" *ngIf="couponCode">
    <div class="co-summary__products__item columns small-6">
      <small>Gesamtsumme weitere Monate:</small>
    </div>
    <div class="co-summary__products__item columns small-6 text-right">
      <small>{{
        defaultTotalPrice | currency : 'EUR' : 'symbol' : '1.2-2'
      }}</small>
    </div>
  </div>
  <div class="co-summary__products" *ngIf="showBackPay">
    <div class="co-summary__products__item columns small-6">
      <small>Einmalige Nachzahlung</small>
      <div
        class="co-icon"
        *ngIf="showCartPage"
        [attr.aria-label]="getTooltipText()"
      >
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path
            fill="#cccccc"
            d="M12.13,11.59 C11.97,12.84 10.35,14.12 9.1,14.16 C6.17,14.2 9.89,9.46 8.74,8.37 C9.3,8.16 10.62,7.83 10.62,8.81 C10.62,9.63 10.12,10.55 9.88,11.32 C8.66,15.16 12.13,11.15 12.14,11.18 C12.16,11.21 12.16,11.35 12.13,11.59 C12.08,11.95 12.16,11.35 12.13,11.59 L12.13,11.59 Z M11.56,5.67 C11.56,6.67 9.36,7.15 9.36,6.03 C9.36,5 11.56,4.54 11.56,5.67 L11.56,5.67 Z"
          ></path>
          <circle
            fill="none"
            stroke-width="1.1"
            stroke="#cccccc"
            cx="10"
            cy="10"
            r="9"
          ></circle>
        </svg>
      </div>
      <span
        *ngIf="!showCartPage"
        [title]="getTooltipText()"
        uk-tooltip="pos: top"
      >
        <span class="uk-margin-small-left uk-text-muted" uk-icon="info"></span>
      </span>
    </div>
    <div class="co-summary__products__item columns small-6 text-right">
      <small>{{ backPay | currency : 'EUR' : 'symbol' : '1.2-2' }}</small>
    </div>
  </div>
  <p class="co-text-legal">
    * Servicepauschale pro Monat/Klasse und Kunden-Konto, daher keine
    zusätzlichen Kosten bei Losnachbestellung.
  </p>
</div>
